import BlogItem from "../../Components/blog/blog-item";

const SingleBlog = () => {
  return <BlogItem />;
};

export default SingleBlog;
